import { getForm, getFormInitialValues } from "./form"

declare global {
  interface Window {
    onUseCustomCheckboxChange: (event: Event, formId: string, controlledFieldId: string) => void
  }
}


window.onUseCustomCheckboxChange = (event, formId, controlledFieldId) => {
  const input = event.target as HTMLInputElement
  const form = getForm(formId)
  const formInitialValues = getFormInitialValues(form)

  if (!form || !input || typeof controlledFieldId !== "string") {
    return
  }

  const checked = input.checked

  const controlledField = form.querySelector(`#${controlledFieldId}`) as HTMLInputElement | undefined
  const controlledFieldName = controlledField?.getAttribute("name")

  if (controlledField && controlledFieldName) {
    const previousInputValue = input.getAttribute("data-previous-input-value") ?? formInitialValues[controlledFieldName]

    const newFieldValue = checked ? previousInputValue : ""

    controlledField.value = newFieldValue.toString()
    controlledField.disabled = !checked
    controlledField.closest(".input__wrap")?.classList.toggle("input__wrap--disabled", !checked)
    controlledField.closest(".textarea__wrap")?.classList.toggle("textarea__wrap--disabled", !checked)
    controlledField.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
